import React from "react";
import "./RulesScreen.css";

const RulesScreen = ({ onStart }) => {
  return (
    <div className="rules-container-full">
      <div className="rules-wrapper">
        <div className="rules-card">
          {/* หัวข้อ */}
          <h3 className="rules-title">
            กติการ่วมสนุก
            <br />
            กิจกรรมตอบคำถาม
          </h3>

          {/* เนื้อหา */}
          <div className="rules-content">
            <ul className="rules-list">
              <li>
                เล่นเกมตอบคำถาม{" "}
                <span className="highlight-text">
                  ลุ้นรับบิ๊กพอยต์ฟรีสูงสุด 100 พอยต์/ครั้ง
                </span>
              </li>
              <li>
                ร่วมสนุกได้{" "}
                <span className="highlight-text">วันละ 1 ครั้ง</span>
              </li>
              <li>สำหรับสมาชิกบิ๊กพอยต์เท่านั้น</li>
              <li>
                หากยังไม่เป็นสมาชิก สามารถร่วมเล่นและรับพอยต์ได้
                แต่ต้องสมัครสมาชิกและ{" "}
                <span className="highlight-text">
                  เคลมสิทธิ์ภายใน 48 ชั่วโมง
                </span>{" "}
                มิฉะนั้นจะถือว่าสละสิทธิ์และพอยต์จะถูกยกเลิก
              </li>
              <li>สมาชิกบิ๊กพอยต์ สามารถรับรางวัลได้ 1 รางวัล/วัน เท่านั้น</li>
              <li>สมาชิกบิ๊กพอยต์ สามารถเชื่อต่อกับ 1 Line Account เท่านั้น</li>
              <li>ร่วมสนุกได้จนกว่าพอยต์ทั้งหมดจะถูกแจกครบตามจำนวนที่กำหนด</li>
              <li>
                พอยต์ไม่สามารถโอนหรือแลกเป็นเงินสดได้
                และบิ๊กซีขอสงวนสิทธิ์ในการเปลี่ยนแปลงเงื่อนไขตามความเหมาะสม
              </li>
              <li>เงื่อนไขต่างๆ เป็นไปตามที่บริษัทกำหนด</li>
            </ul>
          </div>

          {/* ปุ่มเริ่มเกม */}
          <button className="btn-gold-start" onClick={onStart}>
            เริ่มเกม
          </button>
        </div>
      </div>
    </div>
  );
};

export default RulesScreen;
